/* tslint:disable */

/**
 */
export class Membership {
    start_expiration_date?: string;
    id?: number;
    rfidcard_id?: number;
    fullname?: string;
    cmnd?: string;
    gender?: string;
    avatar?: string;
    address?: string;
    phone?: string;
    balance?: number;
    expiration_date?: string;
    ticket_price_id?: number;
    company_id?: number;
    sidn?: string;
    email?: string;
    barcode?: string;
    birthday?: string;
    membershiptype_id?: number;
    duration?: number;
    charge_limit?: number;
    charge_limit_prepaid?: number;
    actived?: number;
    gr_bus_station_id?: number;
    created_at?: string;
    updated_at?: string;
}
